export const PixelToHexVector = [
    [2/3, 0],
    [-1/3, Math.sqrt(3)/3],
    [1/2, Math.sqrt(3)/3]
];

export const HexToPixelVector = [
    [1.5, 0],
    [Math.sqrt(3)/2, Math.sqrt(3)]
];

export const hexRound = (frac) => {
    let q = Math.round(frac[0]);
    let r = Math.round(frac[1]);
    const s = Math.round(-frac[0]-frac[1]);

    const q_diff = Math.abs(q - frac[0]);
    const r_diff = Math.abs(r - frac[1]);
    const s_diff = Math.abs(s - (-frac[0]-frac[1]));

    if (q_diff > r_diff && q_diff > s_diff) {
        q = -r-s;
    } else if (r_diff > s_diff) {
        r = -q-s;
    }

    return [q, r];
}

export const hexRoundCorner = (pointWorld, pointCenter) => {
    const point = Coords.toViewHex(pointWorld, [0,0], [0,0], 100);
    const center = Coords.toViewHex(pointCenter, [0,0], [0,0], 100);
    const angle = Math.atan2(point[1]-center[1], point[0]-center[0]) * 180 / Math.PI;

    if (angle <= 30 && angle > -30) {
        return [pointCenter[0]+PixelToHexVector[0][0], pointCenter[1]+PixelToHexVector[1][0]];
    } else if (angle <= 90 && angle > 30) {
        return [pointCenter[0]-PixelToHexVector[1][0], pointCenter[1]-PixelToHexVector[1][0]];
    } else if (angle <= 150 && angle > 90) {
        return [pointCenter[0]+PixelToHexVector[1][0], pointCenter[1]+PixelToHexVector[0][0]];
    } else if (angle >= -90 && angle < -30) {
        return [pointCenter[0]-PixelToHexVector[1][0], pointCenter[1]-PixelToHexVector[0][0]];
    } else if (angle <= -150 || angle > 150) {
        return [pointCenter[0]-PixelToHexVector[0][0], pointCenter[1]-PixelToHexVector[1][0]];
    } else if (angle >= -150 && angle < -90) {
        return [pointCenter[0]+PixelToHexVector[1][0], pointCenter[1]+PixelToHexVector[1][0]];
    }


    return pointWorld;
}

export default class Coords {

    static mode = 'square';

    static setMode (mode) {
        Coords.mode = mode;
    }

    static toWorld (screenPoint, worldCenter, lookingAt, tileSize) {
        return [
            (screenPoint[0] - worldCenter[0]) / tileSize + lookingAt[0],
            (screenPoint[1] - worldCenter[1]) / tileSize + lookingAt[1]
        ];
    }

    static toWorldHex (screenPoint, worldCenter, lookingAt, tileSize) {
        const q = screenPoint[0]*PixelToHexVector[0][0];
        const r = screenPoint[0]*PixelToHexVector[1][0] + screenPoint[1]*PixelToHexVector[1][1];

        const qWorld = worldCenter[0]*PixelToHexVector[0][0];
        const rWorld = worldCenter[0]*PixelToHexVector[1][0] + worldCenter[1]*PixelToHexVector[1][1];
        
        return [
            2*(q - qWorld) / tileSize + lookingAt[0],
            2*(r - rWorld) / tileSize + lookingAt[1]
        ];
    }

    static toView (worldPoint, viewCenter, lookingAt, tileSize) {
        if (Coords.mode === 'hexagon') {
            return Coords.toViewHex(worldPoint, viewCenter, lookingAt, tileSize)
        }

        return Coords.toViewSqr(worldPoint, viewCenter, lookingAt, tileSize);
    }

    static toViewSqr (worldPoint, viewCenter, lookingAt, tileSize) {
        return [
            worldPoint[0] * tileSize + viewCenter[0] - (lookingAt[0] * tileSize),
            worldPoint[1] * tileSize + viewCenter[1] - (lookingAt[1] * tileSize)
        ]
    }

    static toViewHex (worldPoint, viewCenter, lookingAt, tileSize) {
        const x = worldPoint[0]*HexToPixelVector[0][0];
        const y = worldPoint[0]*HexToPixelVector[1][0] + worldPoint[1]*HexToPixelVector[1][1];
        
        const lookX = lookingAt[0]*HexToPixelVector[0][0];
        const lookY = lookingAt[0]*HexToPixelVector[1][0] + lookingAt[1]*HexToPixelVector[1][1];

        return [
            ((x - lookX)*tileSize/2) + viewCenter[0], 
            ((y - lookY)*tileSize/2) + viewCenter[1]
        ];
    }

    static inRect(point, rect) {
        return (point[0] >= Math.min(rect[0][0], rect[1][0]) && 
            point[0] <= Math.max(rect[0][0], rect[1][0]) && 
            point[1] >= Math.min(rect[0][1], rect[1][1]) && 
            point[1] <= Math.max(rect[0][1], rect[1][1])
        );
    }
}